import { render, staticRenderFns } from "./IntegrationsWizardRegistration.vue?vue&type=template&id=94177ae0&scoped=true&"
import script from "./IntegrationsWizardRegistration.vue?vue&type=script&lang=js&"
export * from "./IntegrationsWizardRegistration.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsWizardRegistration.vue?vue&type=style&index=0&id=94177ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94177ae0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
